module.exports = __webpack_public_path__ + "static/media/rr-4.32e2d0eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/rr-4.png
// module id = 122
// module chunks = 0